<template>
  <div class="form-group-outer" v-if="locationIsEditable || file || locationHasPhoto || alwaysEditable">
    <div class="margin-20"></div>

    <div class="row">
      <div class="col-sm-12 col-lg-8">
        <div class="form-group float-label-control" v-if="(file || locationHasNoPhoto) && (locationIsEditable || alwaysEditable)">
          <label for="">Map Photo</label>
          <input type="text" class="form-control" :value="file ? file.name : null" placeholder="Map Photo" disabled>
        </div>
        <div class="form-group">
          <div class="btn-group btn-group-sm" role="group" v-if="!file && locationHasPhoto">
            <a class="btn btn-primary" :href="location.photo_url" target="_blank"><i class="fa fa-eye"></i> View Photo</a>

            <slot name="delete"></slot>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-lg-4" v-if="locationIsEditable || alwaysEditable">
        <label class="btn btn-primary btn-sm btn-block" for="map_photo">
          <input type="file" class="sr-only" id="map_photo" name="file" accept=".jpg,.jpeg,.png,.gif" @change="handleFileSelection" @input="handleFileSelection">
          Select File
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { LaddaButton } from 'components/forms'
  import helpers from 'mixins/locations/helpers'
  import $ from 'jquery'

  export default {
    mixins: [helpers],

    components: {
      LaddaButton
    },

    props: ['value', 'alwaysEditable'],

    data () {
      return {
        file: null
      }
    },

    watch: {
      /**
       * Watch the parent v-model for changes and set them on the file.
       *
       * @param mixed value
       *
       * @return void
       */
      value (value) {
        this.file = value
      },

      /**
       * When the file changes we emit the input back up to the parent component.
       *
       * @return void
       */
      file () {
        this.$emit('input', this.file)

        if (this.file === null) {
          $(this.$el).closest('form').get(0).reset()
        }
      },

      /**
       * When the route changes we need to reset the file and the form.
       */
      '$route' () {
        this.file = null

        $(this.$el).closest('form').get(0).reset()
      }
    },

    computed: mapState('location', ['location']),

    methods: {
      /**
       * Handle changes to the selected file.
       *
       * @param object files
       *
       * @return void
       */
      handleFileSelection ({ target: { files } }) {
        if (files.length === 0) {
          this.file = null

          return
        }

        this.file = files.item(0)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Photo.vue?2d75e04c